var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-container',{staticClass:"form-container"},[(_vm.service!= null)?_c('Form',{attrs:{"service":_vm.service}}):_vm._e(),_c('HelloWorld',{attrs:{"msg":"Bienvenu.e sur Egadnos, le sondage ethique"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }